import { TEST_RIDE_BOOK_WITH_TIME_SLOT_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export async function bookTestRideWithTimeSlot(testRideData) {
    const response = await Network.post(TEST_RIDE_BOOK_WITH_TIME_SLOT_ENDPOINT, testRideData, {
        headers: {
            Accept: 'application/v2+json',
        },
    });
    return response.data;
}
